/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WeaknessMappingUpsertRequest
 */
export interface WeaknessMappingUpsertRequest {
    /**
     * 
     * @type {string}
     * @memberof WeaknessMappingUpsertRequest
     */
    canonicalWeaknessId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WeaknessMappingUpsertRequest
     */
    cweIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WeaknessMappingUpsertRequest
     */
    mappingVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessMappingUpsertRequest
     */
    mappingSource?: string;
}

/**
 * Check if a given object implements the WeaknessMappingUpsertRequest interface.
 */
export function instanceOfWeaknessMappingUpsertRequest(value: object): value is WeaknessMappingUpsertRequest {
    return true;
}

export function WeaknessMappingUpsertRequestFromJSON(json: any): WeaknessMappingUpsertRequest {
    return WeaknessMappingUpsertRequestFromJSONTyped(json, false);
}

export function WeaknessMappingUpsertRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeaknessMappingUpsertRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'canonicalWeaknessId': json['canonicalWeaknessId'] == null ? undefined : json['canonicalWeaknessId'],
        'cweIds': json['cweIds'] == null ? undefined : json['cweIds'],
        'mappingVersion': json['mappingVersion'] == null ? undefined : json['mappingVersion'],
        'mappingSource': json['mappingSource'] == null ? undefined : json['mappingSource'],
    };
}

export function WeaknessMappingUpsertRequestToJSON(json: any): WeaknessMappingUpsertRequest {
    return WeaknessMappingUpsertRequestToJSONTyped(json, false);
}

export function WeaknessMappingUpsertRequestToJSONTyped(value?: WeaknessMappingUpsertRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'canonicalWeaknessId': value['canonicalWeaknessId'],
        'cweIds': value['cweIds'],
        'mappingVersion': value['mappingVersion'],
        'mappingSource': value['mappingSource'],
    };
}

